import { ExtendableError } from 'ts-error';

export class VersionDeprecatedException extends ExtendableError { }
